"use client";

import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { getErrorBoundary } from "@/lib/bugsnag";

const ErrorBoundary = getErrorBoundary();

function Fallback({ clearError }: { clearError: () => void }) {
  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        p: 3,
        textAlign: "center",
      }}
    >
      <Typography variant="h5">Something went wrong</Typography>
      <Typography variant="body2" color="text.secondary">
        The error has been reported. You can try again, or reload the page.
      </Typography>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button variant="outlined" onClick={clearError}>
          Try again
        </Button>
        <Button variant="contained" onClick={() => window.location.reload()}>
          Reload page
        </Button>
      </Box>
    </Box>
  );
}

export default function AppErrorBoundary({ children }: { children: React.ReactNode }) {
  return <ErrorBoundary FallbackComponent={Fallback}>{children}</ErrorBoundary>;
}
